import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    header: 'Error',
    text: 'The entered address is not found.'
};

const hr = {
    header: 'Pogreška',
    text: 'Unesena adresa nije pronađena.'
};

export const strings: Strings<typeof en> = {en, hr};

